// extracted by mini-css-extract-plugin
export default {"benefitsText":"KindleProgramBenefits-module_benefitsText-MHxiF"};